import { SubNavigation } from '../../../../../types/store';
import { ShopFilters } from '../../../../../types/shop';

// the backend laid out the API expecting shop filters to always reload the page
// when changed, but design has the filters (rightly) behaving more like a form
// where the filter changes don't reload and have to be applied/submitted
//
// it's also unfortunately designed that this single form input (a single radio button)
// controls two form variables when submitted or in the url (min_price, max_price)
//
// because of that, this transform converts the price ranges buried in each single subnavigation
// data into the two values that are maintained in the local form state

export interface PriceRangeType
  extends Pick<ShopFilters, 'min_price' | 'max_price'> {
  label?: string;
}

/** Parses the subnavigation data and extracts an array of { min_price, max_price }
 *  from the url in order to build a backend-driven list of price ranges */
export function transformPriceRanges(
  priceRangeSubnavigation?: SubNavigation
): PriceRangeType[] {
  if (!priceRangeSubnavigation?.options?.length) {
    return [];
  }

  return priceRangeSubnavigation?.options.map(({ subnav: label, url }) => {
    // see https://github.com/whatwg/url/issues/531#issuecomment-660806926 for thismessage use
    const params = new URL(`thismessage:${url}`).searchParams;
    // TODO: ugh crazy to parse the url for this
    const minPriceString = params.get('min_price');
    const maxPriceString = params.get('max_price');
    // where undefined === unset, e.g. no price filter === both unset
    return {
      // unfortunately, we keep the label because the BE will expect it to be sent
      // all the way thru and used
      label,
      min_price: minPriceString ? parseInt(minPriceString, 10) : undefined,
      max_price: maxPriceString ? parseInt(maxPriceString, 10) : undefined,
    };
  });
}
